module.exports = __webpack_public_path__ + "static/media/viv_1.7e46777f.jpg";